import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import '../index.scss'
import AdminPublisherCardEditable from '@Components/Cards/WorkDetailCards/AdminPublisherCards/AdminPublisherCardEditable'
import OriginPublisherCardEditable from '@Components/Cards/WorkDetailCards/OriginalPublisherCards/OriginalPublisherCardEditable'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import { Navigate } from 'react-router'
import RootStore from '@App/stores/root-store'
import { PublisherModel } from '@Entities/work/publisher-model'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

const SHARE_ERROR = 'All parties must have shares and the total shares must not exceed 100.06%'
const SHARE_ERROR_CARD = 'Value must be greater than 0%'

const PublishersShareStep = () => {
    const { workStore, rightsholderStore } = useContext<RootStore>(StoresContext)

    const [errorCards, setErrorCards] = useState<any[]>([])
    const [shareError, setShareError] = useState<string>()
    const [totalShares, setTotalShares] = useState<number>(0)

    const resetErrors = () => {
        setErrorCards([])
    }

    const addErrorCard = (ipId: any) => {
        setErrorCards([...errorCards, ipId])
    }
    const onShareChange = () => {
        resetErrors()
        sharesCounter()
    }

    const sharesValidation = () => {
        if (totalShares > 100.06 && workStore.isOverclaimAllowed) {
            setShareError('')
        } else if (totalShares <= 0 || totalShares > 100.06) {
            setShareError(SHARE_ERROR_CARD)
        } else {
            setShareError('')
        }
    }

    const sharesCounter = () => {
        const workDraftFromLocal = workStore.workDraftLocal

        if (!workDraftFromLocal) {
            setTotalShares(0)
            return
        }
        let shares = 0

        workDraftFromLocal.originalPublishers.forEach((op: OriginalPublisherModel) => {
            shares += Number(op.publisherShare)

            if (op.administratorPublishers.length) {
                op.administratorPublishers.forEach((ap: PublisherModel) => {
                    if (Number(ap.publisherShare) <= 0) {
                        addErrorCard(ap.ipId)
                    }

                    shares += Number(ap.publisherShare)
                })
            } else {
                if (Number(op.publisherShare) <= 0) {
                    addErrorCard(op.ipId)
                }
            }
        })
        setTotalShares(shares)
    }

    const setTotalKnownShares = () => {
        const workDraftFromLocal = workStore.workDraftLocal

        if (!workDraftFromLocal) {
            return
        }

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            totalKnownShares: totalShares,
        }
        workStore.setWorkDraftToLocal(updatedWorkDraft)
    }

    const determineError = (ipId: any) => {
        if (shareError) {
            return SHARE_ERROR
        } else if (errorCards.includes(ipId)) {
            return SHARE_ERROR_CARD
        } else {
            return ''
        }
    }

    useEffect(() => {
        sharesValidation()
        setTotalKnownShares()
    }, [totalShares])

    useEffect(() => {
        onShareChange()
    }, [])

    const triggerDownstreamError = () => {
        if (shareError || errorCards.length > 0) {
            if (workStore.isOverclaimAllowed && +totalShares >= 100.06) {
                workStore.setWizardStepValidation(true)
            } else {
                workStore.setWizardStepValidation(false)
            }
        } else {
            workStore.setWizardStepValidation(true)
        }
    }

    useEffect(() => {
        triggerDownstreamError()
    }, [shareError, errorCards])

    const workDraftFromLocal = workStore.workDraftLocal
    const currentRhId = rightsholderStore.currentRightsholderId

    if (!workDraftFromLocal || !currentRhId) {
        return null
    }

    const typeCreator = location.href.split('/')[7] // HARD CODE
    const originPublishers = workDraftFromLocal.originalPublishers

    if (!originPublishers.length) {
        if (workDraftFromLocal.id) {
            return (
                <Navigate
                    to={`/rightsholder/${currentRhId}/catalog/${workDraftFromLocal.isComplete ? 'work' : 'draft'}/${
                        workDraftFromLocal.id
                    }/edit/publishers`}
                />
            )
        }

        return <Navigate to={`/rightsholder/${currentRhId}/create-work/manual/${typeCreator}/publishers`} />
    }

    return (
        <div className="publishers-step add-shares-step">
            <div className="publishers-cards-wrapper">
                <div className="publishers-add-area">
                    {originPublishers.length
                        ? originPublishers.map((op: OriginalPublisherModel) => (
                              <div className="publisher-wrapper" key={op.localId}>
                                  <div className="publishers-area">
                                      <div className="main-title">
                                          <p className="bold title">Publisher ({op.publisherName ? 1 : 0})</p>
                                          <span className="small bold blue-text">Required</span>
                                      </div>
                                      <OriginPublisherCardEditable
                                          data={op}
                                          shareError={determineError(op.ipId)}
                                          onShareChange={onShareChange}
                                      />
                                  </div>
                                  <div className="publishers-area">
                                      <div className="main-title">
                                          <p className="bold title">
                                              Administrator ({op.administratorPublishers.length})
                                          </p>
                                          <span className="small bold blue-text">Optional</span>
                                      </div>
                                      {op.administratorPublishers.length ? (
                                          op.administratorPublishers.map((ap: PublisherModel) => (
                                              <AdminPublisherCardEditable
                                                  key={ap.localId}
                                                  data={ap}
                                                  parentOP={op}
                                                  shareError={determineError(ap.ipId)}
                                                  onShareChange={onShareChange}
                                              />
                                          ))
                                      ) : (
                                          <p className="small">Administrators were not added</p>
                                      )}
                                  </div>
                              </div>
                          ))
                        : null}
                </div>
            </div>
        </div>
    )
}

export default observer(PublishersShareStep)
